import { format } from 'date-fns';
import React from 'react';
import { connect } from 'react-redux';

import { Actions as AUTHENTICATION_ACTIONS } from '../../store/actions/authenticationActions';

const OrderForm = ({ billingDetails, organisation, promotionCode }) => {
  const ukVAT = 0.2;
  const dateOfToday = format(new Date(), 'dd MMMM yyyy');

  let priceWithCoupon = 0.0;
  const subscriptionPrice = Number(organisation?.subscriptionPrice) || 0;

  const couponDiscounts = promotionCode?.applyDiscount !== false;

  if (organisation?.['stripeCoupon'] && couponDiscounts && promotionCode?.percent_off && subscriptionPrice) {
    priceWithCoupon = subscriptionPrice * (promotionCode['percent_off'] / 100);
  }

  console.log('priceWithCoupon', priceWithCoupon);

  const grossFinalPrice = subscriptionPrice - priceWithCoupon;
  const tax = billingDetails?.['country'] === 'United Kingdom' ? grossFinalPrice * ukVAT : 0.0;
  const netFinalPrice = grossFinalPrice + tax;

  const companyNumber =
    !billingDetails?.['companyNumber'] || billingDetails['companyNumber'] === ''
      ? 'Not specified'
      : billingDetails['companyNumber'];

  const planLabel = organisation?.planId
    ? String(organisation.planId).charAt(0).toUpperCase() + String(organisation.planId).slice(1)
    : organisation?.subscriptionPlan;
  const levelLabel = organisation?.fteBand || organisation?.revenueRange || '—';
  const priceDisplay =
    subscriptionPrice > 0
      ? netFinalPrice.toFixed(2)
      : organisation?.planId
        ? 'As per selected plan at Checkout'
        : '0.00';

  return (
    <>
      <div style={{ textAlign: 'center' }}>
        <img
          src='https://s3.eu-west-2.amazonaws.com/downloads.compareyourfootprint.com/branding/compareyourfootprint/Picture+1.jpg'
          alt=''></img>
      </div>
      <div>
        <p style={{ fontSize: 11, color: 'black', textAlign: 'justify' }} className='orderForm-intro'>
          This Order Form ("Order Form") is between <strong>CYF Impact Ltd</strong>, a company incorporated in
          England and Wales (Registered No. 16888001) with its registered office at 71-75 Shelton Street, Covent Garden, London,
          WC2H 9JQ and any of its affiliates (<strong>“CYF”</strong>) and <strong>{organisation.name}</strong> a company
          incorporated in <strong>{billingDetails?.country || '—'}</strong> under Company
          number <strong>{companyNumber}</strong> with
          its registered office at <strong>{billingDetails?.address || '—'}</strong> (<strong>"the Customer"</strong>) and
          relates to
          the Services Agreement entered into between CYF and the Customer dated <strong>{dateOfToday}</strong> (
          <strong>the "Agreement"</strong>).
        </p>
        <ul style={{ listStyle: 'none', paddingBottom: 5 }}>
          <li style={{ textAlign: 'justify', fontSize: 11, color: 'black', paddingBottom: 10 }}>
            <strong>The parties hereby agree as follows:</strong> Order Form. This document constitutes an "Order Form" under
            the Contract, and this Order Form and the Services and Professional Services contemplated herein are subject to
            the terms and provisions of the Contract.
            <ul style={{ paddingLeft: 10, listStyle: 'none' }}>
              <li style={{ listStyle: 'none', paddingBottom: 5 }}>
                1.1 . This document constitutes an "Order Form" in terms of CYF’s{' '}
                <a href='https://www.compareyourfootprint.com/terms-and-conditions/'>Terms and Conditions</a>{' '}
                <strong>(“Terms and Conditions”)</strong>. This Order Form forms part of the Agreement, and this Order
                Form
                is subject to the terms and provisions of the Agreement.
              </li>
              <li style={{ listStyle: 'none', paddingBottom: 5 }}>
                1.2 In this Order Form, unless specified otherwise, words and phrases shall have the same meanings as
                those
                in the Terms and Conditions.
              </li>
              <li style={{ listStyle: 'none' }}>
                1.3 If there is any conflict between the terms of this Order form and the terms of the Agreement, then
                the
                terms of this Order Form shall prevail.
              </li>
            </ul>
          </li>
          <li style={{ textAlign: 'justify', fontSize: 11, color: 'black' }}>
            <strong>Subscription Services</strong>
            <ul style={{ paddingLeft: 10, listStyle: 'none' }}>
              <li style={{ listStyle: 'none', paddingBottom: 5 }}>
                2.1 Subscription Type: <strong>{planLabel} plan. </strong>
              </li>
              <li style={{ listStyle: 'none', paddingBottom: 5 }}>
                2.2 Subscription Level: <strong>{levelLabel} </strong>
              </li>
              <li style={{ listStyle: 'none', paddingBottom: 5 }}>
                2.3 Subscription Term: Three (3) years from date of signature, or another date as mutually agreed, then
                rolling annual contract until terminated by either party on not less than 30 days’ written notice before
                start of new Subscription Term.
              </li>
              <li style={{ listStyle: 'none', paddingBottom: 5 }}>
                2.4 Subscription Services:
                <ul style={{ paddingLeft: 10, listStyle: 'none' }}>
                  <li style={{ listStyle: 'none', paddingBottom: 5 }}>
                    2.4.1 Access to enter data into the CYF online carbon footprint calculator and benchmarking software
                    and
                    receive carbon emissions results and reports - available at{' '}
                    <a href='https://app.compareyourfootprint.com'>app.compareyourfootprint.com</a>;
                  </li>
                  <li style={{ listStyle: 'none', paddingBottom: 5 }}>
                    2.4.2 Unlimited facilities / project / usage data and carbon emissions reporting;
                  </li>
                  <li style={{ listStyle: 'none', paddingBottom: 5 }}>
                    2.4.3 Downloadable results reports in PDF and Excel formats;
                  </li>
                  <li style={{ listStyle: 'none', paddingBottom: 5 }}>
                    2.4.4 First line support through access to the knowledge hub;
                  </li>
                  <li style={{ listStyle: 'none', paddingBottom: 5 }}>
                    2.4.5 Access to support team at{' '}
                    <a href='mailto:support@compareyourfootprint.com'>support@compareyourfootprint.com</a>
                  </li>
                  <li style={{ listStyle: 'none', paddingBottom: 5 }}>
                    2.4.6 Invitation to Sustainability Solved online community sustainabilitysolved.org offering
                    <ul style={{ paddingLeft: 30, listStyle: 'none' }}>
                      <li style={{ paddingBottom: 5 }}>
                        Free support, guidance and resources on carbon footprinting, carbon reduction and environmental
                        management
                      </li>
                      <li style={{ paddingBottom: 5 }}>Access to sustainable business podcasts</li>
                      <li style={{ paddingBottom: 5 }}>Access to online sustainability training</li>
                      <li style={{ paddingBottom: 5 }}>
                        Opportunity to network with professionals across different industries.
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li style={{ listStyle: 'none', paddingBottom: 5 }}>
                3. Subscription Service Fees:
                <ul style={{ listStyle: 'none' }}>
                  <li style={{ listStyle: 'none', paddingBottom: 5 }}>3.1 Fees set out in the table below</li>
                  <li style={{ listStyle: 'none', paddingBottom: 5 }}>
                    3.2 Full Payment Terms set out in the{' '}
                    <a href='https://www.compareyourfootprint.com/terms-and-conditions/'>Terms and
                      Conditions</a> (Clause
                    13).
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
        <table style={{ margin: 'auto' }}>
          <thead style={{ border: '1px solid black', fontWeight: 'bold', color: 'black' }}>
            <tr>
              <th style={{ borderRight: '1px solid black', padding: 5, fontSize: 12 }}>Subscription</th>
              <th style={{ borderRight: '1px solid black', padding: 5, fontSize: 12 }}>Fee</th>
              <th style={{ borderRight: '1px solid black', padding: 5, fontSize: 12 }}>Term</th>
              <th style={{ borderRight: '1px solid black', padding: 5, fontSize: 12 }}>Subtotal</th>
            </tr>
          </thead>
          <tbody style={{ border: '1px solid black', fontWeight: 'bold', color: 'black' }}>
            <tr>
              <td id='subscription-details' style={{ borderRight: '1px solid black', padding: 5, fontSize: 10 }}>
                Subscription services <br /> Type: {planLabel || 'Annual'} plan. <br /> Level: {levelLabel}{' '}
              </td>
              <td style={{ borderRight: '1px solid black', padding: 5, fontSize: 10 }}>£ 0.00</td>
              <td style={{ borderRight: '1px solid black', padding: 5, fontSize: 10 }}>3 years</td>
              <td id='subscription-subtotal' style={{ borderRight: '1px solid black', padding: 5, fontSize: 10 }}>
                Subtotal <br /> £ {priceDisplay}
              </td>
            </tr>
          </tbody>
        </table>
        <p
          style={{
            color: 'red',
            fontSize: 11,
            fontWeight: 'bold',
            marginTop: 10,
            display: promotionCode?.['duration_in_months'] ? 'block' : 'none',
          }}>
          This coupon has a duration of {promotionCode?.['duration_in_months']} months in your first subscription
        </p>
        <div style={{ margin: '20px 20px 10px 10px', display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
          <p style={{ color: 'black', fontSize: 11 }}>
            Subtotal{' '}
            <span style={{ paddingLeft: 40, fontWeight: 'bold', color: 'black', fontSize: 11 }}>
              £ {priceDisplay}{' '}
            </span>
          </p>
          <p style={{ color: 'black', fontSize: 11 }}>
            Discount{' '}
            <span style={{ paddingLeft: 40, fontWeight: 'bold', color: 'black', fontSize: 11 }}>
              £{priceWithCoupon.toFixed(2)}
            </span>
          </p>
          <p style={{ color: 'black', fontSize: 11 }}>
            Tax{' '}
            <span id='subscription-tax' style={{ paddingLeft: 40, fontWeight: 'bold', color: 'black', fontSize: 11 }}>
              £ {Number.isFinite(tax) ? tax.toFixed(2) : '0.00'}
            </span>
          </p>
          <p style={{ color: 'black', fontSize: 11 }}>
            <strong>Total</strong>
            <span id='subscription-netPrice' style={{ paddingLeft: 40, fontWeight: 'bold', color: 'black', fontSize: 11 }}>
              £ {subscriptionPrice > 0 && Number.isFinite(netFinalPrice) ? netFinalPrice.toFixed(2) : priceDisplay}
            </span>
          </p>
        </div>
        <div style={{ fontSize: 11 }}>
          <div style={{ marginLeft: 10 }}>
            <p style={{ color: 'black', fontSize: 12 }}>
              <strong>Special Conditions:</strong>
            </p>
            <p style={{ color: 'black', fontSize: 11 }}>
              If there is any conflict or inconsistency between the terms of this Order Form and the Agreement, the terms of
              the Order Form shall have precedence.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  newUserSubscription: (user, organisation) => dispatch(AUTHENTICATION_ACTIONS.newUserSubscription(user, organisation)),
});

const mapStateToProps = (state) => {
  const billingDetails = {
    address: state.payment.billingDetails && state.payment.billingDetails['address'],
    country: state.payment.billingDetails && state.payment.billingDetails['country'],
    vatNumber: state.payment.billingDetails && state.payment.billingDetails['vatNumber'],
    companyNumber: state.payment.billingDetails && state.payment.billingDetails['companyNumber']
  };

  const organisation = {
    name: state?.organisation?.details?.name,
    revenue: state?.profile?.registrationDetails?.organisation?.revenue,
    revenueRange: state.profile?.registrationDetails?.organisation?.revenueRange,
    stripeCoupon: state.profile?.registrationDetails?.organisation?.stripeCoupon,
    subscriptionPlan: state.profile?.registrationDetails?.organisation?.subscriptionPlan,
    subscriptionPrice: state.profile?.registrationDetails?.organisation?.subscriptionPrice,
    companyNumber: state.payment.billingDetails && state.payment.billingDetails['companyNumber'],
    planId: state.payment?.planUpgrade?.planId || state.organisation?.details?.planId,
    fteBand: state.payment?.planUpgrade?.fteBand || state.organisation?.details?.fteBand,
  };

  return {
    billingDetails,
    organisation,
    promotionCode: state?.payment?.stripeCoupon,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderForm);
